import React from "react";
import Footer from "../../common/Footer.js";
import AdminSideNav from "../../common/AdminSideNav.js";
import AnalystSideNav from "../../common/AnalystSideNav.js";
import TopNav from "../../common/TopNav.js";
import requireAuth from "../../hoc/requireAuth.js";
import authorizeAnalystOrAdmin from "../../hoc/authorizeAnalystOrAdmin.js";
import { withAlert } from "react-alert";
import { connect } from "react-redux";
import Scrapper1 from "./Scrapper1.js";
import Scrapper2 from "./Scrapper2.js";
import Scrapper3 from "./Scrapper3.js";

class Scrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: localStorage.getItem("scrapper_active_tab") || "scrapper1",
    };
  }

  setTab = (tab) => {
    localStorage.setItem("scrapper_active_tab", tab);
    this.setState({ activeTab: tab });
  };

  render() {
    const { activeTab } = this.state;
    const login = this.props.login;

    return (
      <div className="row">
        {login?.user?.role === "Admin" ? <AdminSideNav /> : <AnalystSideNav />}

        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
          <TopNav />

          <div className="main-content-container container-fluid px-4 pt-3">
            <ul className="nav nav-tabs mb-4 pt-1">
              {["scrapper1", "scrapper2", "scrapper3"].map((tab, i) => (
                <li className="nav-item" key={tab}>
                  <button
                    className={`nav-link${activeTab === tab ? " active" : ""}`}
                    style={
                      activeTab === tab
                        ? {
                            color: "#c0392b",
                          }
                        : undefined
                    }
                    onClick={() => this.setTab(tab)}
                  >
                    Scrapper {i + 1}
                  </button>
                </li>
              ))}
            </ul>

            {activeTab === "scrapper1" && (
              <Scrapper1 {...this.props} embedded />
            )}
            {activeTab === "scrapper2" && (
              <Scrapper2 {...this.props} embedded />
            )}
            {activeTab === "scrapper3" && (
              <Scrapper3 {...this.props} embedded />
            )}
          </div>

          <Footer />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  login: state.login,
});

export default withAlert()(
  connect(mapStateToProps)(authorizeAnalystOrAdmin(requireAuth(Scrapper))),
);
